import { api } from "@/lib/api";

function getVisitorId() {
  let id = localStorage.getItem("sc_visitor_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random());
    localStorage.setItem("sc_visitor_id", id);
  }
  return id;
}

function getSessionId() {
  let id = sessionStorage.getItem("sc_session_id");
  if (!id) {
    id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now() + Math.random());
    sessionStorage.setItem("sc_session_id", id);
  }
  return id;
}

export function trackPageview(path, title) {
  try {
    api.post("/track/pageview", {
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      path,
      referrer: document.referrer || "",
      title: title || document.title || "",
    });
  } catch (e) {
    /* silent */
  }
}

export function trackEvent(type, label, path) {
  try {
    api.post("/track/event", {
      visitor_id: getVisitorId(),
      session_id: getSessionId(),
      type,
      label,
      path: path || window.location.pathname,
    });
  } catch (e) {
    /* silent */
  }
}
